<template>
  <router-view v-slot="{ Component }">
    <transition>
      <component :is="Component" /> <!-- Change this line to use capital 'C' -->
    </transition>
  </router-view>
</template>

<!-- <script setup>
import { useStore } from 'vuex';
import { onMounted } from 'vue';

const store = useStore();

onMounted(() => store.dispatch('getProjectsFromBackend'));
</script> -->
